import { fromJS } from 'immutable';
import R, { map } from 'ramda';
import * as contractingCnts from '../../../../components/contracting/__storeFiles__/constants';

const initialState = fromJS({
  open: false,
  type: '',
  data: {},
  offersOrExtras: {},
  note: '',
  example: '',
  saving: false,
});


const selectCCTemplate = (state, template) => {
  const targetProducts = state.getIn(['data', 'targetTemplate', 'products']).toJS();
  const matches = !template ? {} : targetProducts.reduce((result, tp) => {
    const foundPFromS = template.products.find(p => p.productId === tp.productId || p.productName === tp.productName);
    if (foundPFromS) result[foundPFromS.productId] = { label: tp.productName, value: tp.productId };
    return result;
  }, {});
  const targetTemplate = state.getIn(['data', 'targetTemplate']).toJS();
  return state.setIn(['data', 'sourceTemplate'], !template ? null : fromJS({
    ...template,
    productsToImport: template.products
      // if target products are empty, import all by default
      .filter(o => targetProducts.length ? matches[o.productId] : true)
      .map(o => o.productId),
  }))
  .setIn(['data', 'matches'], fromJS(matches))
  // if target has no products at all, or we automatically matched every products, there is no need to confuse user with the product match dropdowns
  .setIn(['data', 'noNeedToMatch'], !template ? false : !(targetTemplate.products && targetTemplate.products.length) || template.products.every(p => matches[p.productId]));
};
export default function addEditDialog(state = initialState, { type, payload }) {
  switch (type) {
    case 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE':
      return initialState.set('productId', payload.productId)
        .set('ratePackageIndex', payload.ratePackageIndex)
        .set('ratePackageName', payload.ratePackageName)
        .set('policiesNotesPage', payload.policiesNotesPage)
        .set('type', payload.type)
        .set('policyType', payload.policyType)
        .set('ratePackageId', payload.ratePackageId)
        .setIn(['data', 'title'], payload.title)
        .set('offersOrExtras', payload.offersOrExtras ? fromJS(payload.offersOrExtras) : state.get('offersOrExtras'))
        .update('data', data => data.merge(fromJS(payload.data || {})));
    case 'OPEN_AND_POPULATE_ADD_EDIT_CONTRACT_DIALOG':
      return state.set('open', true)
      .update('data', data => data.merge(fromJS(payload.data || {})))
      .update('offersOrExtras', offersOrExtras => offersOrExtras.merge(fromJS(payload.offersOrExtras || {})));
    case 'PRODUCTS_SAVED_UPDATE_REDUX':
      return initialState.merge(fromJS({
        productId: payload.firstProduct.productId,
        ratePackageIndex: payload.firstProduct.ratePackageIndex,
        ratePackageName: payload.firstProduct.ratePackageName,
        type: 'copyDataFromAnotherProduct',
        data: { title: 'Copy data from another product', noShowIfEmpty: true },
      }));
    case '[contract-product]CREATE_RATE_PACKAGE_SUCCESS':
      if (payload.newRatePackage) {
        return initialState.merge(fromJS({
          _id: payload.newRatePackage._id,
          productId: payload.newRatePackage.productId,
          ratePackageIndex: payload.newRatePackage.ratePackageIndex,
          ratePackageName: payload.newRatePackage.ratePackageName,
          type: 'copyDataFromAnotherProduct',
          data: { title: 'Copy data from another product', noShowIfEmpty: true },
        }));
      }
      return initialState;
    case '{draft}EDIT_PRODUCT_PROFILE_INFO':
    case `${contractingCnts.MANAGE_EXTRAS_OFFERS}_STARTED`:
    case '[contract-product]CREATE_RATE_PACKAGE_START':
    case 'OMNI_IMPORT':
    case 'SAVING_IN_ADD_EDIT_CONTRACT_DIALOG':
      return state.set('saving', true);
    case `${contractingCnts.MANAGE_EXTRAS_OFFERS}_ERROR`:
    case 'OMNI_IMPORT_ERROR':
    case 'COPY_DATA_FROM_ANOTHER_PRODUCT_IN_CONTRACT_IS_FAILED':
      return state.set('saving', false)
        .setIn(['data', 'error'], payload ? payload.error : payload);
    case `${contractingCnts.MANAGE_EXTRAS_OFFERS}_SUCCESS`:
    case '{draft}EDIT_PRODUCT_PROFILE_INFO_SUCCESS':
    case 'OMNI_IMPORT_SUCCESS':
    case 'IMPORT_DATA_FROM_ANOTHER_TEMPLATE_SUCCESS':
    case 'UPDATE_BUYER_INFO':
    case 'SAVE_BILLING_INFO_ADD_EDIT':
    case 'DATA_FROM_ANOTHER_PRODUCT_IS_COPIED':
    case 'CLOSE_ADD_EDIT_CONTRACT_DIALOG':
    case 'CONTRACT_SUPPLIER_DETAIL_UPDATED':
    case 'CONTRACT_PRODUCT_UPDATED':
      return initialState;
    case 'SHOW_CONTRACTING_ERROR_STRING':
      return state.set('saving', false);
    // case 'SELECT_SEASON_IN_EDITING_SEASON_ADHOC':
    //   return state.update('data', data => data.merge(fromJS(payload))).setIn(['data', 'selectedSeasonName'], payload.seasonName);
    case 'ON_CHANGE_TEXTFIELD_WITH_KEYPATH_IN_ADD_EDIT_DIALOG':
      if (Array.isArray(payload.value)) return state.setIn(payload.keyPath, fromJS(payload.value));
      if (payload.value && typeof payload.value === 'object' && typeof payload.value.getMonth !== 'function') {
        return state.updateIn(payload.keyPath, obj => {
          if (!obj) return fromJS(payload.value);
          return obj.merge(fromJS(payload.value));
        });
      }
      return state.setIn(payload.keyPath, payload.value);
    case 'ADD_ONE_ELEMENT_WITH_KEYPATH_ADD_EDIT_DIALOG':
      return state.updateIn(payload.keyPath, array => {
        if (!array) return fromJS([payload.element]);
        return array.push(fromJS(payload.element));
      });
    case 'DELETE_ONE_ELEMENT_WITH_KEYPATH_ADD_EDIT_DIALOG':
      return state.deleteIn(payload.keyPath);
    case 'ON_CHANGE_TEXTFIELD_IN_ADD_EDIT_DIALOG':
      if (payload.key === 'maxAdultsPlusChild') {
        return state.updateIn(['data', 'rates'], map(rate => rate.set('maxAdultsPlusChild', payload.value)));
      }
      if ((payload.key === 'earlyCheckInCostType' || payload.key === 'lateCheckOutCostType') && payload.value === '%') {
        if (payload.key === 'earlyCheckInCostType') return state.setIn(['data', payload.key], payload.value).setIn(['data', 'earlyCheckInPercentageType'], 'of Nightly Rate');
        if (payload.key === 'lateCheckOutCostType') return state.setIn(['data', payload.key], payload.value).setIn(['data', 'lateCheckOutPercentageType'], 'of Nightly Rate');
      }
      if (payload.key === 'eventName') return state.setIn(['data', 'eventName'], payload.value);
      if (payload.updateProductPolicy) {
        if (payload.key === 'policyType') {
          return state.updateIn(['data', 'selectedPolicy'], selectedPolicy => selectedPolicy.merge(fromJS({ policyType: payload.value, conditions: '', cancellations: [{}] })));
        }
        return state.setIn(['data', 'selectedPolicy', payload.key], payload.value);
      }
      if (!isNaN(payload.blackoutsIndex)) return state.setIn(['data', 'blackouts', payload.blackoutsIndex, payload.key], payload.value);
      if (payload.forTermsAndNotes) return state.setIn(['data', 'value'], payload.value);
      return state.setIn(['data', payload.key], payload.value);
    case 'UPDATE_DAYS_OF_WEEK_ADD_EDIT':
      const pathToDOW = payload.pathToDOW || ['data'];
      if (payload.day === 'All') {
        if (payload.checked) return state.setIn([...pathToDOW, 'daysOfWeek'], fromJS(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']));
        return state.setIn([...pathToDOW, 'daysOfWeek'], fromJS([]));
      }
      if (payload.checked) return state.updateIn([...pathToDOW, 'daysOfWeek'], daysOfWeek => daysOfWeek.push(payload.day));
      return state.deleteIn([...pathToDOW, 'daysOfWeek', payload.dayIndexInReducer]);
    case 'UPDATE_TABLE_CELL_ADD_EDIT':
      const pathToRates = payload.pathToRates || ['data'];
      if (payload.column === 'maxChild') {
        return state.updateIn([...pathToRates, 'rates', payload.row], rateDetails => {
          return rateDetails.merge(fromJS({
            maxChild: payload.value,
            maxAdultsPlusChild: parseInt(state.getIn([...pathToRates, 'rates', payload.row, 'maxAdults']), 10) + parseInt(payload.value, 10),
          }));
        });
      }
      if (payload.column === 'minGuests' && payload.row) {
        if (Number(payload.value) <= Number(state.getIn([...pathToRates, 'rates', payload.row - 1, 'minGuests']))) {
          return state.setIn([...pathToRates, 'rates', payload.row, payload.column], Number(payload.value));
        }
        return state.setIn([...pathToRates, 'rates', payload.row - 1, 'maxAdultsPlusChild'], Number(payload.value) - 1)
          .setIn([...pathToRates, 'rates', payload.row, payload.column], Number(payload.value));
      }
      if (state.getIn([...pathToRates, 'nonStandardTemplateType']) === 'priceBreak' && payload.column === 'maxAdultsPlusChild' && payload.row < state.getIn([...pathToRates, 'rates']).size - 1) {
        return state.setIn([...pathToRates, 'rates', payload.row + 1, 'minGuests'], Number(payload.value) + 1)
          .setIn([...pathToRates, 'rates', payload.row, payload.column], payload.value);
      }
      if (payload.column === 'retailRate' && state.getIn([...pathToRates, 'rateType']) === 'includeCommission') {
        return state.setIn([...pathToRates, 'rates', payload.row, 'retailRate'], payload.value)
        .setIn([...pathToRates, 'rates', payload.row, 'nettRate'], Number(payload.value - (payload.value * state.getIn([...pathToRates, 'commissionPercentage'])) / 100).toFixed(2));
      }
      return state.setIn([...pathToRates, 'rates', payload.row, payload.column], payload.value);
    case 'ADD_ONE_MORE_BLACKOUT':
      return state.updateIn(['data', 'blackouts'], blackouts => blackouts.push(fromJS({})));
    case 'DELETE_ONE_BLACKOUT_DAY':
      return state.deleteIn(['data', 'blackouts', payload.index]);
    case 'ADD_ONE_MORE_ALLOTMENT':
      return state.updateIn(['data', 'allotments'], allotments => allotments.push(fromJS({})));
    case 'DELETE_ONE_ALLOTMENT':
      return state.deleteIn(['data', 'allotments', payload.index]);
    case 'ADD_INSURANCE_FILE':
      return state.setIn(['data', 'insuranceFiles'], fromJS(payload));
    case 'REMOVE_INSURANCE_FILE':
      return state.setIn(['data', 'insuranceFiles'], fromJS([]));
    case 'HANDLE_COPY_TEMPLATE_SELECTION':
      if (payload.fieldName) return state.setIn(['data', 'value'], payload.value);
      return state;
    case 'SEARCH_CC_RATES_TEMPLATES':
      return state.setIn(['data', 'loadingCCTemplates'], true);
    case 'SEARCH_CC_RATES_TEMPLATES_SUCCESS':
      return state.setIn(['data', 'loadingCCTemplates'], false)
      .setIn(['data', 'templates'], fromJS(payload.templates));
    case 'SELECT_OMNI_IMPORT_SOURCE_TEMPLATE':
      return selectCCTemplate(state, payload.template);
    case 'RateDocIframe_selectImportTemplate':
      if (payload.forCCImport) {
        const template = state.getIn(['data', 'templates']).toJS().find(o => o.originalContractId ? payload.docId === o.originalContractId : payload.docId === o._id);
        return selectCCTemplate(state, template);
      }
      return state.setIn(['data', 'templateSelected'], fromJS({ _id: payload.docId }));
    // when DL manually enters id, this is what we do
    case 'LOAD_PRODUCTS_FOR_OMNI_IMPORT_SOURCE_TEMPLATE':
      return state.setIn(['data', 'sourceTemplate'], fromJS({
        loadingProducts: true,
        ...payload.template,
      }));
    case 'LOAD_PRODUCTS_FOR_OMNI_IMPORT_SOURCE_TEMPLATE_SUCCESS':
      return state.setIn(['data', 'sourceTemplate', 'products'], fromJS(payload.productsArray))
        .setIn(['data', 'sourceTemplate', 'templateId'], payload.templateId)
        .setIn(['data', 'sourceTemplate', 'productsToImport'], fromJS(R.uniq(payload.productsArray.map(o => o.productId))))
        .setIn(['data', 'matches'], fromJS(state.getIn(['data', 'targetTemplate', 'products']).toJS().reduce((result, tp) => {
          const foundPFromS = payload.productsArray.find(p => p.productId === tp.productId || p.productName === tp.productName);
          if (foundPFromS) result[foundPFromS.productId] = { label: tp.productName, value: tp.productId };
          return result;
        }, {})))
        .setIn(['data', 'sourceTemplate', 'loadingProducts'], false);
    case 'LOAD_PRODUCTS_FOR_OMNI_IMPORT_SOURCE_TEMPLATE_ERROR':
      return state.setIn(['data', 'sourceTemplate', 'loadingProducts'], true);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/dialogs/dialog-reducers/add-edit-contract-dialog-reducer.js